export default __webpack_public_path__ + "static/media/tealTop.8e8a2343.png";